// import React from "react";
// import LoadingBar from "react-top-loading-bar";
// import Tab from 'components/common/Tab';
// import { constant } from 'constants/constant';
// import MainDashboard from "./MainDashboard";
// import VehicleDashboard from "./VehicleDashboard";
// import { useSearchParams } from "react-router-dom";

// const Dashboard = () => {
//   const loadingBarRef = React.useRef(null)

//   const [searchParams, setSearchParams] = useSearchParams();

//   const activeTabParam = parseInt(searchParams.get("t"), 10);
//   const activeTab = isNaN(activeTabParam) ? 1 : activeTabParam;

//   const handleTabChange = (t) => {
//     setSearchParams({ t: t.toString() });
//   };


//   const simulateLoading = () => {
//     loadingBarRef.current.continuousStart();
//     setTimeout(() => {
//       loadingBarRef?.current?.complete();
//     }, 1000); // Adjust this timeout as needed to simulate loading time
//   };

//   // Simulate loading when the component mounts
//   React.useEffect(() => {
//     simulateLoading();
//   }, []);

//   const tabProps = {
//     tabList: constant.dashboardTabs,
//     // callBackTab: (e) => setActiveTab(e),
//     callBackTab: handleTabChange,
//     activeTab: activeTab
//   };

//   return (
//     <>
//       {/* <Heading title={"Dashboard"} /> */}
//       {/* <div>Dashboard</div> */}
//       {/* <AddAccount /> */}
//       <LoadingBar
//         color="#ffa800"
//         ref={loadingBarRef}
//         height={4}
//         shadow={true}
//         loaderSpeed={1000}
//       />

//       <div className='addPr_flBx'>
//         <Tab {...tabProps} />
//         {activeTab === 1 && (
//           <MainDashboard />
//         )}

//         {activeTab === 2 && (
//           <VehicleDashboard />
//         )}
//       </div >


//     </>
//   );
// };

// export default Dashboard;


import React from "react";
import LoadingBar from "react-top-loading-bar";
import Tab from 'components/common/Tab';
import MainDashboard from "./MainDashboard";
import VehicleDashboard from "./VehicleDashboard";
import { useSearchParams } from "react-router-dom";
import { constant } from 'constants/constant';
import GpsTimeline from "./GpsTimeline";
import NewGpsTimeline from "./NewGpsTimeline";
import "./dashboard.css"

const Dashboard = () => {

  const loadingBarRef = React.useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();

  // Get tab key from URL (?t=vehicle)
  const tabKey = searchParams.get("t") || "dashboard";

  // Find the matching tab object
  const activeTabObj = constant.dashboardTabs.find(tab => tab.value === tabKey);
  const activeTab = activeTabObj ? activeTabObj.id : 1;

  // Change tab via tab ID → update URL with tab key
  const handleTabChange = (tabId) => {
    const selectedTab = constant.dashboardTabs.find(tab => tab.id === tabId);
    if (selectedTab) {
      setSearchParams({ t: selectedTab.value });
    }
  };

  const simulateLoading = () => {
    loadingBarRef.current?.continuousStart();
    setTimeout(() => {
      loadingBarRef?.current?.complete();
    }, 1000);
  };

  React.useEffect(() => {
    simulateLoading();
  }, []);

  const tabProps = {
    tabList: constant.dashboardTabs,
    callBackTab: handleTabChange,
    activeTab: activeTab
  };

  return (
    <>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />

      <div className="_trpDetail_bx mainGps_trpDetail_bx">
        <div className='addPr_flBx'>
          <Tab {...tabProps} />
          {activeTab === 1 && <MainDashboard />}
          {activeTab === 2 && <VehicleDashboard />}
          {activeTab === 3 && <GpsTimeline />}
          {activeTab === 4 && <NewGpsTimeline />}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
